"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addSide = exports.insertMilestone = exports.sortItems = exports.prepareCards = exports.CompanyCardTree = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const index_1 = require("../index");
require("./index.scss");
const CompanyCardTree = (props) => {
    const { className = '', cards, milestones = [1990, 1995, 2000, 2005], } = props;
    const blockName = 'company-card-tree';
    const classNames = (0, classnames_1.default)(blockName, className);
    const items = prepareCards(cards, milestones);
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("div", { className: `${blockName}__top` }),
        react_1.default.createElement("div", { className: `${blockName}__container` }, items.map((item, idx) => renderItem(item, blockName, idx))),
        react_1.default.createElement("div", { className: `${blockName}__bottom` })));
};
exports.CompanyCardTree = CompanyCardTree;
function renderItem(item, blockName, index) {
    const key = 'type' in item && item.type === 'milestone'
        ? `${item}${index}`
        : item.title + item.period + index;
    if ('type' in item && item.type === 'milestone') {
        const className = item.side === 'left'
            ? `${blockName}__year ${blockName}__year--left` : `${blockName}__year ${blockName}__year--right`;
        return (react_1.default.createElement("div", { className: className, key: key }, item.value));
    }
    else if ((item === null || item === void 0 ? void 0 : item.side) === 'left') {
        return (react_1.default.createElement("div", { className: `${blockName}__item ${blockName}__item--left`, key: key },
            react_1.default.createElement(index_1.CompanyCard, { image: item.image, name: item.title, city: item.direction, duration: item.period })));
    }
    else if ((item === null || item === void 0 ? void 0 : item.side) === 'right') {
        return (react_1.default.createElement("div", { className: `${blockName}__item ${blockName}__item--right`, key: key },
            react_1.default.createElement(index_1.CompanyCard, { image: item.image, name: item.title, city: item.direction, duration: item.period })));
    }
    return null;
}
function prepareCards(items, milestones) {
    const milestonesWithSide = milestones.map(milestone => ({
        type: 'milestone',
        value: milestone,
        side: 'left',
    }));
    const sortedItems = sortItems(items);
    const itemsWithMilestones = insertMilestone(sortedItems, milestonesWithSide);
    return addSide(itemsWithMilestones);
}
exports.prepareCards = prepareCards;
function sortItems(items) {
    return items.sort((a, b) => a.sortYear - b.sortYear);
}
exports.sortItems = sortItems;
function insertMilestone(items, milestones) {
    const result = [];
    for (let i = 0; i < milestones.length; i++) {
        const currentMilestone = milestones[i];
        const nextMilestone = i !== milestones.length - 1 ? milestones[i + 1] : { value: Infinity };
        result.push(currentMilestone);
        const itemsToInsert = items.filter((item) => item.sortYear >= currentMilestone.value && item.sortYear < nextMilestone.value);
        result.push(...itemsToInsert);
    }
    return result;
}
exports.insertMilestone = insertMilestone;
function addSide(items) {
    const copyItems = [...items];
    let currentSide = 'left';
    for (const item of items) {
        if ('type' in item && item.type === 'milestone') {
            item.side = currentSide;
            continue;
        }
        // @ts-ignore
        item.side = currentSide;
        currentSide = switchSide(currentSide);
    }
    return copyItems;
}
exports.addSide = addSide;
function switchSide(currentSide) {
    return currentSide === 'left' ? 'right' : 'left';
}
//# sourceMappingURL=index.js.map